<div class="chat-details-container">
  <div class="spinner-container" *ngIf="loading">
    <mat-spinner diameter="70" class="custom-spinner"></mat-spinner>
  </div>
  <div class="chat-details-content" [hidden]="loading">
    <!-- messages -->
    <div
      #scrollContainer
      cdkScrollable
      class="message-box-scroll"
      (scroll)="onScroll()"
    >
      <app-chats-details-item
        *ngFor="let msg of messages; index as i"
        [msg]="msg"
        [itemDetails]="itemDetails"
        [roomMembersLength]="roomMembersLength"
        [idUserFromRoom]="idUserFromRoom"
        [(forward)]="enableForward"
        (onUploadCanceled)="onCancelUpload($event, msg)"
        (onUploadSuccessed)="onSuccessUpload($event, msg)"
        (onDeleteMessageClicked)="deleteMessage($event, msg)"
        (onSelectForward)="onSelectForward($event, msg)"
        (retrySendRoomMessage)="retrySendRoomMessage(msg)"
        (retrySendUserMessage)="retrySendUserMessage(msg)"
      >
      </app-chats-details-item>
    </div>

    <!-- forward component -->
    <app-chat-forward-message
      *ngIf="enableForward && idChannel"
      [forwardMessages]="forwardList"
      [idChannel]="idChannel"
      (onComplete)="onCompleteForward($event)"
    ></app-chat-forward-message>

    <div class="send-message-and-attachments-container" *ngIf="!enableForward">
      <!-- send message -->
      <div class="send-message-container">
        <mat-form-field class="form-field-message">
          <textarea
            matInput
            cdkTextareaAutosize
            #autosize="cdkTextareaAutosize"
            cdkAutosizeMinRows="1"
            cdkAutosizeMaxRows="4"
            [placeholder]="placeholder"
            [(ngModel)]="sendMessageText"
            (input)="sendMessageChange($event)"
            (keydown.enter)="onKeydownEnter()"
            (keydown.control.enter)="onKeydownControlEnter()"
          >
          </textarea>
        </mat-form-field>
        <div
          *ngIf="attachIconVisible"
          type="button"
          class="btn-attach"
          (click)="hiddenfileinput.click()"
        >
          <img src="../../../../assets/icons/attach.svg" />
          <input
            #hiddenfileinput
            type="file"
            accept="image/*, .pdf"
            id="upload"
            hidden
            (change)="onFileChange($event)"
            multiple
          />
        </div>
        <button
          type="button"
          [ngClass]="
            !sendButtonDisable
              ? 'btn-send-message'
              : 'btn-send-message-disabled'
          "
          (click)="sendMessageClick()"
          [disabled]="sendButtonDisable"
        >
          <mat-icon>send</mat-icon>
        </button>
        <button
          *ngIf="
            idRoom !== undefined
            && ((itemDetails?.ticketFunctionalityActive && hasTicketsFeatures())
            || ticket)"
          type="button"
          [ngClass]="defineTicketCollorButton()"
          (click)="requestTicketClosure()"
          [disabled]="disableTicketButton()"
        >
          <mat-icon>confirmation_number</mat-icon>
        </button>
      </div>
    </div>
  </div>
</div>
